// extracted by mini-css-extract-plugin
export default {"request":"style_request__S6DQN","text":"style_text__Nq83g","button":"style_button__SurY-"};